import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function Pager({ page, pages, total, size, onPage, testid = "pager" }) {
  if (pages <= 1) return null;
  const from = page * size + 1, to = Math.min(total, (page + 1) * size);
  const btn = "flex h-8 min-w-8 items-center justify-center rounded-lg border border-line bg-white px-2 text-xs font-bold text-slate-600 transition-colors hover:border-brand disabled:opacity-40";
  return (
    <div className="mt-4 flex flex-wrap items-center justify-between gap-3" data-testid={testid}>
      <p className="text-xs text-slate-500" data-testid={`${testid}-info`}>{from}–{to} dari {total}</p>
      <div className="flex items-center gap-1">
        <button onClick={() => onPage(page - 1)} disabled={page === 0} className={btn} aria-label="Sebelumnya" data-testid={`${testid}-prev`}><ChevronLeft size={14} /></button>
        <span className="px-2 text-xs font-semibold text-slate-700" data-testid={`${testid}-current`}>Hal. {page + 1} / {pages}</span>
        <button onClick={() => onPage(page + 1)} disabled={page >= pages - 1} className={btn} aria-label="Berikutnya" data-testid={`${testid}-next`}><ChevronRight size={14} /></button>
      </div>
    </div>
  );
}
